import script from "./EventEditModal.vue?vue&type=script&lang=js"
export * from "./EventEditModal.vue?vue&type=script&lang=js"

import "./EventEditModal.vue?vue&type=style&index=0&id=1b9175c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b9175c4"],['__file',"src/containers/event/eventSettings/EventEditModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b9175c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b9175c4', __exports__)) {
    api.reload('1b9175c4', __exports__)
  }
  
}


export default __exports__